<template lang="pug">

div.settings-manager
    md-list.settings-manager__content
        md-list-item.settings-manager__item(
            v-for="sett of setts",
            :key="sett.NAME"
            :md-expand="true")
            md-icon whatshot
            span.md-title {{ sett.TITLE }}
            v-settings.md-dense(
                slot="md-expand"
                :sett="sett")
</template>

<script>

import Settings from './Settings'

export default {
    name: 'v-settings-manager',
    components: {
        'v-settings': Settings
    },
    props: {
        setts: {
            name: 'Settings list',
            type: Array,
            txtDescr: `Array of the displayed settings`,
            editable: _ => false,
            default: _ => [],
        }
    },
    created() {
        console.log('Set Man', this.setts)
    }
}
</script>

<style lang="sass">

.settings-manager
</style>



// WEBPACK FOOTER //
// src/settings/vue/SettingsManager.vue